import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class AppTranslocoLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);
  private static readonly CACHE_BUST = Date.now().toString(36);

  getTranslation(locale: string) {
    return this.http.get<Translation>(`/assets/i18n/${locale}.json?v=${AppTranslocoLoader.CACHE_BUST}`);
  }
}
